import onSpotlightDismissedFromLV from '../actions/onSpotlightDismissedFromLV';
import onSpotlightItemsFetched from '../actions/onSpotlightItemsFetched';
import SpotlightItem from '../store/schema/SpotlightItem';
import SpotlightReason from '../store/schema/SpotlightReason';
import getStore from '../store/store';
import { getSelectedTableView, MailRowDataPropertyGetter } from 'owa-mail-list-store';
import { getQueryStringParameter } from 'owa-querystring';
import { mutator } from 'satcheljs';

mutator(onSpotlightItemsFetched, actionMessage => {
    const { spotlightItems: spotlightItemsFromServer, isConversationView } = actionMessage;
    const testSpotlightItems = getTestSpotlightItems();
    const spotlightItems = spotlightItemsFromServer.concat(testSpotlightItems);

    /**
     * Ensure there's no duplication between the list of actual Spptlight items
     * returned from the service and items marked as Spotlight via the test param.
     */
    const uniqueIds = [];
    const uniqueSpotlightItems = spotlightItems
        .concat(testSpotlightItems)
        .filter((spotlightItem: SpotlightItem) => {
            const id = isConversationView ? spotlightItem.conversationId : spotlightItem.itemId;

            if (uniqueIds.indexOf(id) > -1) {
                return false;
            }

            uniqueIds.push(id);
            return true;
        });

    getStore().spotlightItems = uniqueSpotlightItems;
});

mutator(onSpotlightDismissedFromLV, actionMessage => {
    const rowKey = actionMessage.rowKey;
    const spotlightItems = getStore().spotlightItems;

    for (let i = 0; i < spotlightItems.length; i++) {
        const spotlightItem = spotlightItems[i];

        if (spotlightItem.rowKey === rowKey) {
            spotlightItems.splice(i, 1);
            break;
        }
    }
});

const getTestSpotlightItems = (): SpotlightItem[] => {
    const testSpotlightItems: SpotlightItem[] = [];
    const testSpotlightQueryParam = getQueryStringParameter('testSpotlight');

    if (testSpotlightQueryParam) {
        const tableView = getSelectedTableView();
        const testItemsCount = parseInt(testSpotlightQueryParam);

        for (let i = 0; i < testItemsCount; i++) {
            const row = tableView.rowKeys[i];

            if (row) {
                testSpotlightItems.push({
                    rowKey: row,
                    itemId: MailRowDataPropertyGetter.getItemIds(row, tableView)[0],
                    conversationId: MailRowDataPropertyGetter.getConversationId(row, tableView),
                    isUnseen: true,
                    reason: SpotlightReason.None,
                    senderName: MailRowDataPropertyGetter.getLastSenderMailbox(row, tableView).Name,
                });
            }
        }
    }

    return testSpotlightItems;
};
